/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import dayjs from "dayjs"
import { showInfoToast } from "../../../components/CustomToast"
import ZyutyuHaisyaService from "../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import { TZyutyuHaisyaListGetRes } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import { TApiResponse } from "../../../service/TApiResponse"
import { setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import ZyomuinUnkoGeppoV2Service from "../../../service/driverpayroll/zyomuinUnkoGeppoV2/zyomuinUnkoGeppoV2Service"
import { TZyomuinUnkoGeppo2TeatePutReq } from "../../../service/driverpayroll/zyomuinUnkoGeppoV2/TZyomuinUnkoGeppoV2"

export type T手当編集2Argument = {
  乗務員運行月報2ID: number
  乗務員運行月報明細2ID: number
  社員ID: number
  社員番号: string
  氏名: string
  受注配車ID: number
  受注配車更新日時: string
  乗務員運行月報明細更新日時: string
}

/**
 * 手当情報修正モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const TeateEditModalV2: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    editItemSource: T手当編集2Argument
    setIsEdited: (value: boolean) => unknown
  }
> = (props) => {
  const dispatch: AppDispatch = useDispatch()
  //#region [state]
  const [old食事代, setOld食事代] = useState<number>()
  const [old特別手当, setOld特別手当] = useState<number>()
  const [oldその他手当, setOldその他手当] = useState<number>()
  const [食事代, set食事代] = useState<number>()
  const [特別手当, set特別手当] = useState<number>()
  const [その他手当, setその他手当] = useState<number>()
  const [対象日, set対象日] = useState<string>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]

  const search = async () => {
    setIsSpinnerShow(false)
    setAlertSource(undefined)
    try {
      const service = new ZyutyuHaisyaService()
      const res = (await service.get(
        props.editItemSource.受注配車ID.toString()
      )) as TApiResponse<TZyutyuHaisyaListGetRes>
      if (res.data) {
        setOld食事代(res.data.食事手当 ?? 0)
        setOld特別手当(res.data.特別手当 ?? 0)
        setOldその他手当(res.data.その他手当 ?? 0)
        set食事代(res.data.食事手当 ?? 0)
        set特別手当(res.data.特別手当 ?? 0)
        setその他手当(res.data.その他手当 ?? 0)
        set対象日(res.data.請求計上日)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSpinnerShow(false)
    }
  }

  const beforeSubmit = () => {
    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      const service = new ZyomuinUnkoGeppoV2Service()
      const putData: TZyomuinUnkoGeppo2TeatePutReq = {
        食事手当: 食事代,
        特別手当: 特別手当,
        その他手当: その他手当,
        受注配車ID: props.editItemSource.受注配車ID,
        受注配車更新日時: props.editItemSource.受注配車更新日時,
        乗務員運行月報明細更新日時:
          props.editItemSource.乗務員運行月報明細更新日時,
      }

      const putres = await service.putTeate(
        props.editItemSource.乗務員運行月報明細2ID.toString(),
        putData
      )

      dispatch(setAlerts(putres))
      if (putres) {
        props.setIsEdited(true)
        showInfoToast(`手当の修正が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      props.setIsShow(false)
    }
  }
  //#endregion

  //#region [effect]

  useEffect(() => {
    if (props.isShow) {
      search()
    }
  }, [props.isShow])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "手当編集"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <Button
          type="submit"
          variant="waiting"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            beforeSubmit()
          }}>
          更新
        </Button>
      }>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid className="label-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-8rem">日付</th>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "4rem" }}
                          id="日付"
                          name="日付"
                          value={dayjs(対象日).format("DD") + "日"}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                        <TextInput
                          style={{ width: "4rem" }}
                          id="曜日"
                          name="曜日"
                          value={"(" + dayjs(対象日).format("dd") + ")"}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="min-w-8rem">氏名</th>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "5rem" }}
                          id="社員番号"
                          name="社員番号"
                          value={props.editItemSource.社員番号}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                        <TextInput
                          style={{ width: "12rem" }}
                          id="氏名"
                          name="氏名"
                          value={props.editItemSource.氏名}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <br></br>
          <Table className="form-table">
            <tbody>
              <tr>
                <th className="min-w-8rem"></th>
                <td>
                  <div
                    style={{
                      width: "6rem",
                      marginRight: "2rem",
                      textAlign: "center",
                    }}>
                    <span>変更前</span>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      width: "6rem",
                      textAlign: "center",
                    }}>
                    <span>変更後</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">食事手当</th>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="old食事代"
                      name="old食事代"
                      format={"n0"}
                      value={old食事代}
                      isDisabled={true}
                    />
                  </div>
                </td>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="食事代"
                      name="食事代"
                      format={"n0"}
                      value={食事代}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set食事代(c.value)
                          : set食事代(undefined)
                      }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">特別手当</th>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="old特別手当"
                      name="old特別手当"
                      format={"n0"}
                      value={old特別手当}
                      isDisabled={true}
                    />
                  </div>
                </td>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="特別手当"
                      name="特別手当"
                      format={"n0"}
                      value={特別手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set特別手当(c.value)
                          : set特別手当(undefined)
                      }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">その他手当</th>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="oldその他手当"
                      name="oldその他手当"
                      format={"n0"}
                      value={oldその他手当}
                      isDisabled={true}
                    />
                  </div>
                </td>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="その他手当"
                      name="その他手当"
                      format={"n0"}
                      value={その他手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? setその他手当(c.value)
                          : setその他手当(undefined)
                      }}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default TeateEditModalV2
